export const borderSizeVariables = {
  'border-none': '0px',
  'border-xs': '0.5px',
  'border-sm': '1px',
  'border-xmd': '1.5px',
  'border-md': '2px',
  'border-lg': '3px',
  'border-xl': '4px',
};
